<template>
  <div class="bottom">
    <div class="bottom__logo">
      <a href="https://hello.kion.ru/?utm_source=7days&utm_medium=article&utm_campaign=vertinskij_414221777_q3_2021_abc&utm_content=special&utm_term=article_c_web_mob_int_article_rf_" target="_blank"></a>
    </div>
    <div class="bottom__top">
      <div class="bottom__top-film mobile"></div>
      <div class="bottom__top-film desktop"></div>
      <div class="bottom__top-text">
        <p>Стать подлинным «красивым русским» сегодня, почувствовать новый ритм фокстрота, оказаться рядом с самыми притягательными женщинами мира, пережить самое отвязное десятилетие двадцатого века, скитаясь по самым ярким городам планеты — уже невозможно.</p>
        <p>Но возможно приблизиться к этому на умопомрачительно малое расстояние, посмотрев премьеру сериала «Вертинский» на KION прямо сейчас!</p>
        <a href="https://kion.onelink.me/aJR1?pid=dcm_media&is_retargeting=true&af_click_lookback=30d&af_dp=https%3A%2F%2Fkion.ru%2Fvideo%2Fserial%2F414221777%2Fseason%2F414220180%2Fepisode%2F414224945&af_web_dp=https%3A%2F%2Fkion.ru%2Fvideo%2Fserial%2F414221777%2Fseason%2F414220180%2Fepisode%2F414224945%3Futm_source%3D7days%26utm_medium%3Darticle%26utm_campaign%3Dvertinskij_414221777_q3_2021_abc%26utm_term%3Darticle_c_web_mob_int_article_rf_%26utm_content%3Dspecial&c=vertinskij_414221777_q3_2021_abc&af_adset=7days_article_article_c_web_mob_int_article_rf_special&af_sub1=https%253A%252F%252Fkion.ru%252Fvideo%252Fserial%252F414221777%252Fseason%252F414220180%252Fepisode%252F414224945" target="_blank">Cмотреть</a>
      </div>
    </div>
    <div class="bottom__content">
      <div class="bottom__left">
        <div class="bottom__title">KION — это онлайн-кинотеатр, который <span></span>вы точно полюбите</div>
        <div class="bottom__text">Оригинальные сериалы. Тысячи фильмов и более 200 ТВ-каналов. Детский профиль с безопасным контентом. И возможность смотреть фильмы и сериалы лучших российских и зарубежных студий — без рекламы и в отличном качестве, в любое время <br>и там, где вам удобно.</div>
        <div class="bottom__button">
          <a href="https://hello.kion.ru/?utm_source=7days&utm_medium=article&utm_campaign=vertinskij_414221777_q3_2021_abc&utm_content=special&utm_term=article_c_web_mob_int_article_rf_" target="blank">Бесплатно 30 дней</a>
        </div>
        <div class="bottom__note">KION за 199 рублей в месяц. Пробный период — 30 дней. Требуется регистрация. Отменить подписку можно в любой момент.</div>
      </div>
      <div class="bottom__right">
        <img src="../assets/img/ts.jpg" class="desktop" alt="">
        <img src="../assets/img/bottom-m-2.jpg" class="mobile" alt="">
      </div>
    </div>
    <div class="desktop">
      <div class="footer">
        <div class="footer__left">
          <div class="footer__logo">
            <a href="https://7days.ru/" target="_blank"></a>
          </div>
        </div>
        <div class="footer__share">
          <div class="share">
            <div class="share__label">Поделиться:</div>
            <div class="share__list">
              <a href="javascript:void(0)" class="share__item share__item--fb" data-url="https://kion.7days.ru/" data-title="Вертинский - История великого русского артиста" @click="share('fb')" data-type="fb" ref="fb"></a>
              <a href="javascript:void(0)" class="share__item share__item--vk" data-url="https://kion.7days.ru/" data-title="Вертинский - История великого русского артиста" @click="share('vk')" data-type="vk" ref="vk"></a>
              <a href="javascript:void(0)" class="share__item share__item--ok" data-url="https://kion.7days.ru/" data-title="Вертинский - История великого русского артиста" @click="share('ok')" data-type="ok" ref="ok"></a>
              <a href="javascript:void(0)" class="share__item share__item--tw" data-url="https://kion.7days.ru/" data-title="Вертинский - История великого русского артиста" @click="share('twitter')" data-type="twitter" ref="twitter"></a>
              <a href="javascript:void(0)" class="share__item share__item--tg" data-url="https://kion.7days.ru/" data-title="Вертинский - История великого русского артиста" @click="share('telegram')" data-type="telegram" ref="telegram"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div class="footer">
        <div class="footer__share">
          <div class="share">
            <div class="share__label">Поделиться:</div>
            <div class="share__list">
              <a href="javascript:void(0)" class="share__item share__item--fb" data-url="https://kion.7days.ru/" data-title="Вертинский - История великого русского артиста" @click="share('fb')" data-type="fb" ref="fb"></a>
              <a href="javascript:void(0)" class="share__item share__item--vk" data-url="https://kion.7days.ru/" data-title="Вертинский - История великого русского артиста" @click="share('vk')" data-type="vk" ref="vk"></a>
              <a href="javascript:void(0)" class="share__item share__item--ok" data-url="https://kion.7days.ru/" data-title="Вертинский - История великого русского артиста" @click="share('ok')" data-type="ok" ref="ok"></a>
              <a href="javascript:void(0)" class="share__item share__item--tw" data-url="https://kion.7days.ru/" data-title="Вертинский - История великого русского артиста" @click="share('twitter')" data-type="twitter" ref="twitter"></a>
              <a href="javascript:void(0)" class="share__item share__item--tg" data-url="https://kion.7days.ru/" data-title="Вертинский - История великого русского артиста" @click="share('telegram')" data-type="telegram" ref="telegram"></a>
            </div>
          </div>
        </div>
        <div class="footer__left">
          <div class="footer__logo">
            <a href="https://7days.ru/" target="_blank"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JSShare from "js-share";
export default {
  name: 'Bottom',
  methods: {
    share(soc) {
      JSShare.go(this.$refs[soc]);
    }
  }
}
</script>

<style lang="sass">
  .bottom
    background-color: #0C102C
    min-height: vw(200px)
    display: flex
    flex-direction: column
    @media screen and (max-width: 999px)
      margin-top: vwm(16px)
    &__content
      display: flex
      @media screen and (max-width: 999px)
        flex-direction: column-reverse
    &__left
      width: vw(457px)
      margin-left: vw(198px)
      @media screen and (max-width: 999px)
        width: vwm(375px)
        margin-left: 0
    &__note
      font-size: vw(9.9px)
      line-height: vw(10px)
      font-family: 'Gotham Pro'
      margin-top: vw(23px)
      color: #A5A5A5
      @media screen and (max-width: 999px)
        margin: auto
        margin-top: vwm(23px)
        font-size: vwm(12px)
        line-height: vwm(14px)
        padding-bottom: vwm(34px)
        text-align: center
        width: 90%
    &__button
      a
        width: vw(309px)
        margin-left: vw(-2px)
        height: vw(59px)
        background-color: #D91E25
        text-align: center
        margin-top: vw(39px)
        display: block
        line-height: vw(57px)
        color: #fff
        font-size: vw(18px)
        text-decoration: none
        border-radius: vw(5px)
        font-family: 'Gotham Pro'
        border: 1px solid #D91E25
        transition: all 300ms
        @media screen and (max-width: 999px)
          width: vwm(327px)
          border-radius: vwm(5px)
          margin-left: vwm(-2px)
          font-size: vwm(20px)
          line-height: vwm(57px)
          height: vwm(59px)
          margin: auto
          margin-top: vwm(65px)
        &:hover
          background-color: #fff
          color: #000
    &__right
      width: vw(696px)
      margin-left: auto
      margin-top: vw(56px)
      @media screen and (max-width: 999px)
        width: 100vw
        margin-left: 0
        margin-top: vwm(66px)
      img
        width: 100%
    &__title
      margin-top: vw(76px)
      font-size: vw(27px)
      line-height: vw(28px)
      font-family: 'Gotham Pro'
      @media screen and (max-width: 999px)
        margin-top: vwm(63px)
        font-size: vwm(27px)
        line-height: vwm(28px)
        text-align: center
        span
          display: block
    &__text
      margin-top: vw(26px)
      font-size: vw(16px)
      line-height: vw(18px)
      font-family: 'Gotham Pro'
      @media screen and (max-width: 999px)
        font-size: vwm(17px)
        line-height: vwm(18px)
        text-align: center
        width: 90%
        margin: auto
        margin-top: vwm(28px)
        br
          display: none
    &__top
      display: flex
      @media screen and (max-width: 999px)
        flex-direction: column
      &-text
        width: vw(473px)
        margin-left: vw(82px)
        padding-top: vw(83px)
        font-size: vw(16px)
        line-height: vw(18px)
        font-family: 'Gotham Pro'
        @media screen and (max-width: 999px)
          width: vwm(333px)
          font-size: vwm(17px)
          text-align: center
          margin-top: vwm(38px)
          line-height: vwm(18.5px)
        p
          margin-bottom: vw(16px)
          @media screen and (max-width: 999px)
            margin-bottom: vwm(18px)
        a
          display: block
          width: vw(202px)
          height: vw(59px)
          background-color: #fff
          text-align: center
          text-decoration: none
          color: #000
          font-size: vw(18px)
          line-height: vw(59px)
          margin-left: vw(3px)
          margin-top: vw(41px)
          transition: all 300ms
          border-radius: vw(5px)
          @media screen and (max-width: 999px)
            width: vwm(225px)
            height: vwm(59px)
            line-height: vwm(59px)
            font-size: vwm(20px)
            margin: auto
            border-radius: vwm(6px)
            margin-top: vwm(34px)
          &:hover
            background-color: #D91E25
            color: #fff
      &-film
        width: vw(707px)
        height: vw(326px)
        background-image: url(../assets/img/bottom-1.png)
        background-size: contain
        background-repeat: no-repeat
        background-position: 0 50%
        margin-top: vw(42px)
        @media screen and (max-width: 999px)
          width: 100vw
          height: vwm(257px)
          background-image: url(../assets/img/bottom-m-1.jpg)
          margin-top: vwm(32px)
    &__logo
      width: vw(289px)
      height: vw(92px)
      background-image: url(../assets/img/logo-2.png)
      background-size: contain
      background-repeat: no-repeat
      margin: auto
      margin-top: vw(19px)
      position: relative
      @media screen and (max-width: 999px)
        width: vwm(235px)
        height: vwm(70px)
        margin-top: vwm(30px)
      a
        display: block
        width: 100%
        height: 100%
        position: absolute
  .footer
    padding-bottom: vw(27px)
    display: flex
    width: 100%
    @media screen and (max-width: 999px)
      flex-direction: column
      background-color: #fff
    &__logo
      width: vw(341px)
      height: vw(45px)
      background-image: url(../assets/img/sd-logo.svg)
      background-size: contain
      background-repeat: no-repeat
      margin-left: vw(54px)
      margin-top: vw(32px)
      @media screen and (max-width: 999px)
        width: vwm(186px)
        height: vwm(88px)
        margin-left: auto
        margin-right: auto
        margin-top: vwm(45px)
        margin-bottom: vwm(60px)
        background-image: url(../assets/img/f-logo.svg)
    &__share
      margin-left: auto
      @media screen and (max-width: 999px)
        margin-left: 0
        text-align: center
  .share
    display: flex
    align-items: center
    margin-top: vw(34px)
    margin-right: vw(62px)
    @media screen and (max-width: 999px)
      flex-direction: column
      padding-top: vwm(24px)
      margin-right: 0
    &__list
      display: flex
      align-items: center
    &__label
      font-family: 'Gotham Pro'
      font-size: vw(16px)
      padding-right: vw(3px)
      @media screen and (max-width: 999px)
        color: #000
        font-size: vwm(16px)
        padding-right: 0px
        margin-bottom: vwm(17.1px)
        text-align: center
    &__item
      margin-left: vw(19px)
      width: vw(38px)
      height: vw(38px)
      border-radius: 50%
      background-repeat: no-repeat
      background-position: 50% 50%
      border: vw(1px) solid #fff
      transition: all 300ms
      @media screen and (max-width: 999px)
        width: vwm(43px)
        height: vwm(43px)
        border-color: #000
        margin-left: vwm(10.7px)
        margin-right: vwm(10.7px)
      &:hover
        border-color: #E1C99C
      &--tg
        background-size: vw(20.4px)
        background-image: url(../assets/img/tg.svg)
        @media screen and (max-width: 999px)
          background-size: vwm(23px)
          background-image: url(../assets/img/tg-m.svg)
        &:hover
          background-image: url(../assets/img/tg-h.svg)
      &--vk
        background-size: vw(20.9px)
        background-image: url(../assets/img/vk.svg)
        @media screen and (max-width: 999px)
          background-size: vwm(24px)
          background-image: url(../assets/img/vk-m.svg)
        &:hover
          background-image: url(../assets/img/vk-h.svg)
      &--ok
        background-size: vw(11.4px)
        background-image: url(../assets/img/ok.svg)
        @media screen and (max-width: 999px)
          background-size: vwm(12px)
          background-image: url(../assets/img/ok-m.svg)
        &:hover
          background-image: url(../assets/img/ok-h.svg)
      &--fb
        background-size: vw(9.5px)
        background-image: url(../assets/img/fb.svg)
        @media screen and (max-width: 999px)
          background-size: vwm(11px)
          background-image: url(../assets/img/fb-m.svg)
        &:hover
          background-image: url(../assets/img/fb-h.svg)
      &--tw
        background-size: vw(18.6px)
        background-image: url(../assets/img/tw.svg)
        @media screen and (max-width: 999px)
          background-size: vwm(21px)
          background-image: url(../assets/img/tw-m.svg)
        &:hover
          background-image: url(../assets/img/tw-h.svg)

</style>
